import { LocalNotification, PartitionedBanners } from './types';

export const getPartitionedBanners = (
  banners: LocalNotification[],
): PartitionedBanners => {
  return banners.reduce(
    (prev: PartitionedBanners, banner) => {
      const bannerType = banner.type.toLowerCase();
      // PartitionedBanners has no bucket for every BANNER_TYPE ('success' is
      // only counted in `total`), so this lookup can miss; the Array.isArray
      // guard is that fallback, hence the `| undefined` element type.
      const bucket = (
        prev as unknown as Record<
          string,
          LocalNotification[] | number | undefined
        >
      )[bannerType];
      if (Array.isArray(bucket)) {
        bucket.push(banner);
      }
      prev.total += 1;
      return prev;
    },
    {
      error: [],
      warning: [],
      info: [],
      total: 0,
    },
  );
};
